import axios from "../../config/axios";

const apiGetBranch = async (keyword, lat, lng) => {
  try {
    const result = await axios.get(
      `/app/site/list?keyword=${keyword}&latitude=${lat}&longitude=${lng}`,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("rondori_token"),
        },
      }
    );
    return result && result.data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

const apiGetBanner = async () => {
  try {
    const result = await axios.get(`/app/banner/list`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("rondori_token"),
      },
    });
    return result && result.data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

const apiGetNameUser = async (code, type_login) => {
  try {
    const result = await axios.get(
      `/app/auth/token?code=${code}&type=${type_login}`
    );
    return result && result.data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

const apiGetMachineList = async (site_id) => {
  try {
    const result = await axios.get(`/app/machine/list?site_id=${site_id}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("rondori_token"),
      },
    });
    return result && result.data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

const apiGetStatusMachine = async (machine_id) => {
  try {
    const result = await axios.get(
      `/app/machine/bill?machine_id=${machine_id}`,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("rondori_token"),
        },
      }
    );
    return result && result.data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

const apiRemoteStartMachine = async (data) => {
  try {
    const result = await axios.post(`/app/machine/start`, data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("rondori_token"),
      },
    });
    return result && result.data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

const apiGetMyCoupon = async (data) => {
  try {
    const result = await axios.get(`/app/promotion/coupon`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("rondori_token"),
      },
    });
    return result && result.data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

export {
  apiGetBranch,
  apiGetBanner,
  apiGetNameUser,
  apiGetMachineList,
  apiGetStatusMachine,
  apiRemoteStartMachine,
  apiGetMyCoupon,
};
